{
  "familyId": "REK-CIJF-PLUS",
  "questions": [
    {
      "id": "REK-CIJF-PLUS-001",
      "familyId": "REK-CIJF-PLUS",
      "module": "Basisrekenen",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "cijferend",
      "subSkill": "cijferend_optellen",
      "questionType": "cijferend_optellen",
      "question": "Reken cijferend uit: 347 + 285",
      "options": [],
      "correctAnswer": "632",
      "data": {
        "operand1": 347,
        "operand2": 285
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Cijferend optellen — stap voor stap",
            "content": "Zet de getallen onder elkaar. Begin rechts:\n• Eenheden: 7 + 5 = 12 → schrijf 2, onthoud 1\n• Tientallen: 4 + 8 + 1 = 13 → schrijf 3, onthoud 1\n• Honderdtallen: 3 + 2 + 1 = 6\nAntwoord: 632",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "cijferend_optellen_onthouden",
      "variantIndex": 1,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.64,
      "feedback": {
        "explanationText": "Zet 347 en 285 onder elkaar en begin rechts bij de eenheden. Eenheden: 7 + 5 = 12 → schrijf 2, onthoud 1. Tientallen: 4 + 8 + 1 (onthouden) = 13 → schrijf 3, onthoud 1. Honderdtallen: 3 + 2 + 1 = 6. Antwoord: 632.",
        "solutionSteps": [
          "Zet onder elkaar: 347 + 285",
          "Eenheden: 7 + 5 = 12 → schrijf 2, onthoud 1",
          "Tientallen: 4 + 8 + 1 = 13 → schrijf 3, onthoud 1",
          "Honderdtallen: 3 + 2 + 1 = 6",
          "Antwoord: 632"
        ]
      }
    },
    {
      "id": "REK-CIJF-PLUS-002",
      "familyId": "REK-CIJF-PLUS",
      "module": "Basisrekenen",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "cijferend",
      "subSkill": "cijferend_optellen",
      "questionType": "cijferend_optellen",
      "question": "Reken cijferend uit: 1.456 + 2.378",
      "options": [],
      "correctAnswer": "3.834",
      "data": {
        "operand1": 1456,
        "operand2": 2378
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Cijferend optellen — 4 cijfers",
            "content": "Zet onder elkaar en begin rechts:\n• E: 6 + 8 = 14 → schrijf 4, onthoud 1\n• T: 5 + 7 + 1 = 13 → schrijf 3, onthoud 1\n• H: 4 + 3 + 1 = 8\n• D: 1 + 2 = 3\nAntwoord: 3.834",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "cijferend_optellen_viercijferig",
      "variantIndex": 2,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.66,
      "feedback": {
        "explanationText": "Zet 1.456 en 2.378 onder elkaar. Eenheden: 6 + 8 = 14 → schrijf 4, onthoud 1. Tientallen: 5 + 7 + 1 = 13 → schrijf 3, onthoud 1. Honderdtallen: 4 + 3 + 1 = 8. Duizendtallen: 1 + 2 = 3. Antwoord: 3.834.",
        "solutionSteps": [
          "Zet onder elkaar: 1.456 + 2.378",
          "Eenheden: 6 + 8 = 14 → schrijf 4, onthoud 1",
          "Tientallen: 5 + 7 + 1 = 13 → schrijf 3, onthoud 1",
          "Honderdtallen: 4 + 3 + 1 = 8",
          "Duizendtallen: 1 + 2 = 3",
          "Antwoord: 3.834"
        ]
      }
    },
    {
      "id": "REK-CIJF-PLUS-003",
      "familyId": "REK-CIJF-PLUS",
      "module": "Basisrekenen",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "cijferend",
      "subSkill": "cijferend_optellen",
      "questionType": "fill_in",
      "question": "Een school bestelt 468 schriften en later nog 357 schriften. Hoeveel schriften zijn er in totaal besteld?",
      "options": [],
      "correctAnswer": "825",
      "data": {
        "acceptedAnswers": ["825"]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "column",
          "showWhen": "wrong",
          "data": {
            "operand1": 468,
            "operand2": 357,
            "operation": "+"
          }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Optellen met context",
            "content": "Je moet optellen: 468 + 357. Begin rechts:\n• E: 8 + 7 = 15 → schrijf 5, onthoud 1\n• T: 6 + 5 + 1 = 12 → schrijf 2, onthoud 1\n• H: 4 + 3 + 1 = 8\nAntwoord: 825 schriften",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "cijferend_optellen_context",
      "variantIndex": 3,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.68,
      "feedback": {
        "explanationText": "De school bestelt 468 + 357 schriften. Eenheden: 8 + 7 = 15 → schrijf 5, onthoud 1. Tientallen: 6 + 5 + 1 = 12 → schrijf 2, onthoud 1. Honderdtallen: 4 + 3 + 1 = 8. Totaal: 825 schriften.",
        "solutionSteps": [
          "Herken de bewerking: 468 + 357",
          "Eenheden: 8 + 7 = 15 → schrijf 5, onthoud 1",
          "Tientallen: 6 + 5 + 1 = 12 → schrijf 2, onthoud 1",
          "Honderdtallen: 4 + 3 + 1 = 8",
          "Antwoord: 825 schriften"
        ]
      }
    },
    {
      "id": "REK-CIJF-PLUS-004",
      "familyId": "REK-CIJF-PLUS",
      "module": "Basisrekenen",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "cijferend",
      "subSkill": "cijferend_optellen",
      "questionType": "multiple_choice",
      "question": "Bij cijferend optellen van 576 + 248: wat schrijf je bij de tientallen?",
      "options": ["2 (en onthoud 1)", "12", "7", "1 (en onthoud 1)"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Stap voor stap — tientallen",
            "content": "Eerst de eenheden: 6 + 8 = 14 → schrijf 4, onthoud 1. Dan de tientallen: 7 + 4 + 1 (onthouden) = 12 → schrijf 2, onthoud 1. Je schrijft dus 2 bij de tientallen.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "cijferend_optellen_tussenresultaat",
      "variantIndex": 4,
      "citoDifficulty": 0.20,
      "citoDiscrimination": 0.62,
      "feedback": {
        "explanationText": "Bij de tientallen reken je: 7 + 4 = 11, plus 1 onthouden van de eenheden = 12. Je schrijft 2 op en onthoudt 1 voor de honderdtallen. Het volledige antwoord: 576 + 248 = 824.",
        "solutionSteps": [
          "Eenheden: 6 + 8 = 14 → schrijf 4, onthoud 1",
          "Tientallen: 7 + 4 + 1 = 12 → schrijf 2, onthoud 1",
          "Honderdtallen: 5 + 2 + 1 = 8",
          "Antwoord: 824"
        ],
        "distractorExplanations": {
          "0": "Goed! 7 + 4 + 1 (onthouden) = 12. Je schrijft 2 en onthoudt 1.",
          "1": "Je dacht waarschijnlijk dat je het hele getal 12 opschrijft. Maar bij cijferend rekenen schrijf je alleen het laatste cijfer (2) en onthoud je het eerste cijfer (1) voor de volgende kolom.",
          "2": "Je dacht waarschijnlijk alleen aan 7 + 4 = 11, maar je vergat de 1 die je onthield van de eenheden (6 + 8 = 14). Het wordt 7 + 4 + 1 = 12.",
          "3": "Je dacht waarschijnlijk dat je 1 opschrijft en 1 onthoudt. Maar 7 + 4 + 1 = 12, niet 11. Het cijfer dat je opschrijft is 2, niet 1."
        }
      }
    },
    {
      "id": "REK-CIJF-PLUS-005",
      "familyId": "REK-CIJF-PLUS",
      "module": "Basisrekenen",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "cijferend",
      "subSkill": "cijferend_optellen",
      "questionType": "cijferend_optellen",
      "question": "Reken cijferend uit: 695 + 189",
      "options": [],
      "correctAnswer": "884",
      "data": {
        "operand1": 695,
        "operand2": 189
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Dubbel onthouden",
            "content": "Soms moet je twee keer onthouden:\n• E: 5 + 9 = 14 → schrijf 4, onthoud 1\n• T: 9 + 8 + 1 = 18 → schrijf 8, onthoud 1\n• H: 6 + 1 + 1 = 8\nAntwoord: 884",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "cijferend_optellen_dubbel_onthouden",
      "variantIndex": 5,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.65,
      "feedback": {
        "explanationText": "695 + 189: Eenheden: 5 + 9 = 14 → schrijf 4, onthoud 1. Tientallen: 9 + 8 + 1 = 18 → schrijf 8, onthoud 1. Honderdtallen: 6 + 1 + 1 = 8. Antwoord: 884. Let op: je moet hier twee keer onthouden!",
        "solutionSteps": [
          "Eenheden: 5 + 9 = 14 → schrijf 4, onthoud 1",
          "Tientallen: 9 + 8 + 1 = 18 → schrijf 8, onthoud 1",
          "Honderdtallen: 6 + 1 + 1 = 8",
          "Antwoord: 884"
        ]
      }
    }
  ]
}